export default {"src":"/_next/static/media/mcap.31c70ada.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};